import { render, staticRenderFns } from "./BookingDuplicateShortlistTalent.vue?vue&type=template&id=86589436"
import script from "./BookingDuplicateShortlistTalent.vue?vue&type=script&lang=js"
export * from "./BookingDuplicateShortlistTalent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports